import { render, staticRenderFns } from "./VendedoresDetail.vue?vue&type=template&id=57e9dc70&"
import script from "./VendedoresDetail.vue?vue&type=script&lang=js&"
export * from "./VendedoresDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports